// extracted by mini-css-extract-plugin
export default {"row":"styles_row__60Qf+","row_flex":"styles_row_flex__97T8O"};